import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import StudentPanelMenu from "./StudentPanelMenu";
import StudentRightsCheck from "./StudentRightsCheck";
import { scrollToTop } from "../Shared/ScrollOnTop";

function StudentPanelLedger(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const UserName = localStorage.getItem("UserName") || "";

  const [loading, setLoading] = useState(false);
  const [listOfChallans, setListOfChallans] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    document.title = "Student Ledger - Challans";
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Student_ID: parseInt(UserID, 10) || 0,
      Registration_No: UserName,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Student/GetChallansForStudent",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfChallans(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setListOfChallans([]);
          setTotalRecords(0);
          if (response.data.status_code !== 0) {
            toast.error(response.data.status_message || "No challans found.", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [UserID, UserName]);

  const renderChallans = () => {
    if (listOfChallans != null && listOfChallans.length > 0) {
      return listOfChallans.map((item, index) => {
        const amount = item.Due_Date_Amount != null ? item.Due_Date_Amount : item.After_Due_Date_Amount;
        return (
          <tr key={item.Challan_No || index}>
            <td>{index + 1}</td>
            <td>{item.Challan_No}</td>
            <td>{item.Month}/{item.Year}</td>
            <td>{item.Due_Date ? moment(item.Due_Date).format("DD/MM/YYYY") : "-"}</td>
            <td className="text-end">{amount != null ? amount : "-"}</td>
            <td className="text-center">
              <span className={`badge ${item.Is_Paid ? "bg-success" : "bg-warning text-dark"}`}>
                {item.Is_Paid ? "Paid" : "Unpaid"}
              </span>
            </td>
            <td className="text-center">
              <Link
                to={`/students/PrintVoucher/?ChallanNos=${encodeURIComponent(item.Challan_No || "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="button button-primary button-small"
                onClick={scrollToTop}
              >
                <i className="ri-printer-line me-1"></i>
                Print
              </Link>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="7">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No challans found.
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <StudentPanelMenu />
      <ToastContainer />
      <StudentRightsCheck />

      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink onClick={scrollToTop} to="/student-panel/dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Student Ledger
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Student Ledger</div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content mt-3">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <p className="text-muted mb-3">
                  All generated challans for your account. You can print a challan using the Print button.
                </p>
                <table className="table table-theme">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Challan No</th>
                      <th>Month / Year</th>
                      <th>Due Date</th>
                      <th>Amount</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="7">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      renderChallans()
                    )}
                  </tbody>
                </table>
                {!loading && listOfChallans.length > 0 && (
                  <div className="mt-2">
                    <strong>{totalRecords}</strong> challan(s) found.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentPanelLedger;
